import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import setUiMessage from '../../../Utilities/Tostify';
import { post } from '../../Auths/AuthToken';
import Button from '../../Button';

function TimeSlot({
  resource,
  appDate,
  location,
  addThisTimeSlot,
  closeTimeShlot,
}) {
  const [appointmentTotalCount, setAppointmentTotalCount] = useState(0);
  const [totalNewPatApp, setTotalNewPatApp] = useState(0);
  const [period, setPeriod] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/appointment/appointment/suggestTimePop',
          {
            selectdResource: resource,
            selectdDate: format(appDate, 'yyyy-MM-dd'),
            selectedLocation: location,
          }
        );

        if (response.status === 200) {
          setAppointmentTotalCount(response?.data?.appointmentTotalCount);
          setTotalNewPatApp(response?.data?.totalNewPatApp);
          setPeriod(response?.data?.period);
        }
      } catch (err) {
        setUiMessage('suc', err.message);
      }
    })();
  }, [resource, appDate, location]);
  return (
    <div className="time-slot-popupx">
      <div className="time-slot-head">
        <div className="time-slot-total-app">
          Total Appointments:
          <span className="apntmnt-count-hdr">{appointmentTotalCount}</span>
        </div>
        <div className="">
          New Pt:
          <span className="apntmnt-count-hdr">{totalNewPatApp}</span>
        </div>
        <Button className="right red bold" onClick={closeTimeShlot}>
          X
        </Button>
      </div>
      <div className="time-slot-body">
        {period &&
          period.map((data, idx) => {
            return (
              <div
                key={idx}
                className={
                  idx % 5 === 0 || idx % 2 === 0
                    ? 'time-slot-first-block'
                    : 'time-slot-first-block'
                }
                style={
                  data?.chk === 0
                    ? { backgroundColor: '#fafaaa', cursor: 'default' }
                    : {}
                }
                onClick={
                  data?.chk === 1
                    ? () => addThisTimeSlot(data?.firstcalvalParameter)
                    : null
                }
              >
                <div className="apntmnt-time left">{data?.firstcalvalShow}</div>
                <div className="apntmnt-count left">{data?.midPart}</div>
                <div
                  className="apntmnt-time right"
                  style={{ textAlign: 'right' }}
                >
                  {data?.lastcalvalShow}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default TimeSlot;
